const ACCEPTANCE_STORAGE_KEY = 'UARM_DRAFT_ACCEPT_DATA';
const SERVICE_URL = '/draft/';

import axios from 'axios'

// костыль для PIRS2018-3800: лечим им изначально косячную архитектуру, когда throttled вызов
// случается через intervalParam секунд - уже после того, как например нажали Сохранить (и пошёл запрос delete)
// по уму конечно сюда надо vuex и очередь запросов, но...
const flowCrutch = {
	apply: function(data) {
		var intervalParam = intervalMemory.get();
		if (intervalParam === 0) {
			return
		}
		window[flowCrutch.varName] = flowCrutch.getValueByData(data);
		window.setTimeout(function() {
			delete window[flowCrutch.varName];
		}, intervalParam * 1000)
	},
	check: function(data) {
		return window[flowCrutch.varName] && window[flowCrutch.varName] === flowCrutch.getValueByData(data);
	},
	getValueByData: function(dr){
		return dr.siteId + '-' + dr.armId + '-' + dr.recordId;
	},
	varName: 'UARM_DRAFT_FLOW_CRUTCH',
}

const intervalMemory = {
	storageKey: 'UARM_DRAFT_INTERVAL_MEMORY',
	get: function() {
		// внимание! значением может быть нолик
		var stored = parseInt(window.sessionStorage.getItem(intervalMemory.storageKey));
		var result;
		if (isNaN(stored)) {
			result = 5;
			log('Черновики: значение интервала взято умолчательное 5 секунд');
		}
		else {
			result = stored;
		}
		if (result === 0) {
			log('Черновики отключены (service.draft.interval == 0)')
		}
		return result;
	},
	set: function(v) {
		window.sessionStorage.setItem(intervalMemory.storageKey, v);
	},
}

export default {
	serviceUrl: SERVICE_URL,
	// draft-bell при нажатии на "принять изменения" кладет в сессию черновик и делает переход
	// draft-splash вычитывает это значение, проверяет и применяет данные черновика
	// почему класть сам черновик и зачем его хранить вообще на клиенте? Потому что для уже существующих записей всё просто: мы получаем черновик с сервера с запросом данных. А вот для новых (когда человек нажал добавить, вбил текст и у него выключили свет) так не получится, тк запроса данных нет. Можно конечно добавить опциональное получение определенного черновика в запрос метаданных, но лучше и проще уж имхо на клиенте.
	acceptance: {
		setAndGo: function(dr) {
			window.sessionStorage.setItem(ACCEPTANCE_STORAGE_KEY, JSON.stringify(dr));
			log('Черновик: переходим на ' + dr.editUrl);
			window.location.href = dr.editUrl;
		},
		getAndRemove: function(siteId, armId, recordId) {
			var stored = window.sessionStorage.getItem(ACCEPTANCE_STORAGE_KEY);
			if (stored) {
				window.sessionStorage.removeItem(ACCEPTANCE_STORAGE_KEY);
				stored = JSON.parse(stored);
				if (stored.siteId !== siteId || stored.armId !== armId || stored.recordId !== recordId) {
					console.log('Черновики: в памяти был нерелевантный черновик, его значение игнорируется')
					console.log('Значения текущие: ', siteId, armId, recordId);
					console.log('Значения у черновика: ', stored.siteId, stored.armId, stored.recordId);
					stored = void 0;
				}
			}
			return stored;
		},
	},
	doRemove: function(dr) {
		log('Запрос удаления черновика...');
		var data = {
			siteId: dr.siteId,
			armId: dr.armId,
			recordId: dr.recordId,
		}
		flowCrutch.apply(data);
		// странно конечно в axios реализован делит https://github.com/axios/axios/issues/897#issuecomment-343715381
		return axios.delete(SERVICE_URL, {
				data,
			})
			.catch(function(thrown) {
				console.log(thrown)
			})
	},
	log,
	intervalMemory,
	// Ситуация, когда мы получаем данные карточки с выпадушкой: её значение с сервера
	// приезжает как число, а нейм лежит отдельно
	getEnrichedInitialFields: function(rawFields, contextMeta) {
		var IF = JSON.parse(JSON.stringify(rawFields)); // deep copy чтобы ничего не разломать
		for (var f of IF) {
			var fieldMeta = contextMeta.filter((m) => m.dbcolname === f.fieldId)[0];
			var isDropdown = false;
			var isMultiselect = false;
			if(fieldMeta && fieldMeta.ctrlCode){
				isDropdown = fieldMeta.ctrlCode === 'dropdown';
				isMultiselect = fieldMeta.ctrlCode === 'multiselect';
			}
			if (fieldMeta && fieldMeta.srv_options && (isDropdown || isMultiselect)) {
				if (isDropdown) {
					// тупо число
					f.value = getEnrichedValue(f.value, fieldMeta) || f.value;
				}
				else if (isMultiselect && f.value instanceof Array) {
					// массив чисел
					for (let i = 0; i < f.value.length; i++) {
						f.value[i] = getEnrichedValue(f.value[i], fieldMeta) || f.value[i];
					}
				}
			}
		}
		return JSON.stringify(IF);
	},
	mergeNamesFromInitialFieldsToCurrentFields: function(currentFields, initialFields) {
		// --------------------------------------------------------------------------------------------------
		// Это код который добавляет name в поля, значение которых НЕ менялось (данные приехали с сервера)!
		// В поля, которые менялись, name добавляется с помощью updateFullValuesAndMergeItIntoCurrentFields
		// ------------------------------------------------------------------------------------------------
		// Следующий цикл с кучей всего - это ситуация со справочниками: с сервера нам пришла
		// initialFields c человекопонятными полями справочников ({id,name}).
		// Мы в этих полях ничего не меняли, поэтому их {id,name} нет в draftData, они туда не попали:
		// - ни из formData (данные для отправки на сервер при сохранении записи, там только число-id),
		// - ни из optionalPayload (данные с {id,name}, которые контрол отдает если его исправить, но мы-то поля не трогали)
		// Поэтому мы чекаем, что поле не изменялось, и если да, то
		// пихаем туда {id,name} которые были в initialFields.
		// Вложенность if такая, ну, чтобы было lazy evaluation, экономия на спичках.

		for (let cField of currentFields) {
			// если значение есть и либо само является числом, либо является
			// массивом чисел (проверка тупая - на первый элемент - но этого достаточно кмк)
			if (typeof cField.value !== 'undefined' && cField.value !== null) {
				let curVal_isNum = typeof cField.value === 'number'; // число, т.е. единственный выбор
				let curVal_isArrayOfNum = typeof cField.value[0] === 'number'; // массив чисел, т.е. мультивыбор
				let sameField = initialFields.filter(iField => iField.fieldId === cField.fieldId)[0]; // ищем такое же поле в initialFields (не .find, потому что ИЕ не умеет)
				//debugF(cField, sameField, curVal_isNum, curVal_isArrayOfNum, initialFields)
				if ((curVal_isNum || curVal_isArrayOfNum) && sameField && sameField.value) {
					if (typeof sameField.value[0] !== 'undefined') {
						// массив - значит всплывающий выбор или мультивыбор
						if (curVal_isNum && sameField.value[0].id === cField.value) {
							cField.value = sameField.value;
						}
						else if (curVal_isArrayOfNum) {
							if (cField.value.sort().join() === sameField.value.map(v => v.id).sort().join()) {
								// массивы какбы идентичны
								cField.value = sameField.value;
							}
						}
					}
					else if (typeof sameField.value.id === 'number') {
						// выпадушка
						// TODO разобраться почему у выпадушки sameField.value объект (причем без REVERT_VALUE_TO_PLAIN), а не число, и зачем копировать prettyValueForDiff, но сейчас сил нет
						if (sameField.prettyValueForDiff) {
							// копируем значение для выпадушки из initialFields в draftFields
							cField.prettyValueForDiff = sameField.prettyValueForDiff;
						}
					}
				}
			}
		}
	},
	updateFullValuesAndMergeItIntoCurrentFields: function(currentFields, fullValuesMap, optionalPayload) {
		// --------------------------------------------------------------------------------------------------
		// Это код который добавляет name в поля, значение которых менялось!
		// В поля, которые приехали с сервера, name добавляется с помощью mergeNamesFromInitialFieldsToCurrentFields
		// --------------------------------------------------------------------------------------------------
		// складываем полные значения контролов (с неймами выбранных записей к примеру,
		// а не только id, как в выдаче formdataUtil) в отдельный объект, и затем вмерживаем
		// эти значения в выдачу formdataUtil, чтобы в просмотре черновика (draft_diff)
		// были человекопонятные значения, см. PIRS2018-3542
		if (optionalPayload && optionalPayload.hasOwnProperty('fullValue')) {
			// log('optionalPayload:', optionalPayload);
			fullValuesMap[optionalPayload.dbcolname] = optionalPayload.fullValue;
		}
		for (var f of currentFields) {
			if (fullValuesMap[f.fieldId]) {
				// f.TMP_FORMDATA_VALUE = f.value;
				f.value = fullValuesMap[f.fieldId];
			}
		}
	},
	getFieldsWithPrettyValueForDiff: function(arr) {
		var res = []
		arr.forEach(function(f, i) {
			if (f.value && f.value.formField) {
				// проверка с formField - исключаем поля типа "Файл" (PIRS2018-3522)
				return
			}
			if (f.hasOwnProperty('value') === false) {
				f.value = null; // тест! чтобы в initialFields не было отсутствующих полей, потому что тогда случается изменение - null меняется на пустую строку
			}

			// код drafts принимает два поля: value (то, что используется потом клиентом АРМ)
			// и опц. prettyValueForDiff - оно нужно только для показа в АРМ на таблице draft_diff, см. PIRS2018-3542
			/*if (f.rawValue) {
				f.value = f.rawValue; // чтобы во всяких там выпадушках было реальное значение
			}*/

			// Статус публикации - особая выпадушка - без справочника
			if (f.fieldId === 'publish_type_id' && publishTypeNames[f.value]) {
				f.prettyValueForDiff = publishTypeNames[f.value];
			}
			if (f.value !== null) {
				// Кросстаблицы
				if (f.fieldId.startsWith('CROSSFIELD__') && f.value instanceof Array) {
					// проверка на f.value.map - потому что СВЕЖЕЕ значение (не с сервера полученное)
					// - это массив айдишников тупо
					f.prettyValueForDiff = f.value.map(valueObjectToString).join('; \n');
				}
				// Справочники
				else if (f.value.hasOwnProperty('id')) {
					f.prettyValueForDiff = valueObjectToString(f.value);
				}
				// Флаги
				else if (typeof f.value === 'boolean') {
					f.prettyValueForDiff = f.value ? 'Да' : 'Нет';
				}
			}
			else {
				// draftCommon.log('Draft getFieldsWithPrettyValueForDiff: ' + f.fieldId + ' is null')
				f.prettyValueForDiff = ''; // для null отправляем в дифф пустую строку
			}
			res.push(f);
		})
		return res;
	},
	getFieldsForRequest: function(arr) {
		var res = JSON.parse(JSON.stringify(arr)); // deep copy
		res.forEach(function(f, i) {
			// для выпадушек и мультивыбора: у них значение с сервера (а значит, и то, которое ожидает контрол,
			// а значит, и то, которое должно сохраниться в поле value в draft_master) представляет собой тупо число
			// поэтому мы получаем на вход полное значение, делаем из него prettyValueForDiff и
			// возвращаем его к каноническому формату
			if (f.value) {
				// Dropdown
				if (f.value.REVERT_VALUE_TO_PLAIN) {
					f.value = f.value.id;
				}
				// Multiselect
				else if (f.value[0] && f.value[0].REVERT_VALUE_TO_PLAIN) {
					f.value = f.value.map((v) => v.id);
				}
			}
			// delete f.TMP_FORMDATA_VALUE;
			// res.push(f);
		})
		return res;
	},
	flowCrutch_check: flowCrutch.check,
}

function getEnrichedValue(v, fieldMeta) {
	var fullValue = fieldMeta.srv_options.filter((op) => op.id === v)[0];
	if (fullValue) {
		// console.log(f.fieldId + ' has FV')
		// f.prettyValueForDiff = valueObjectToString(fullValue);  Поэтому сразу пишем prettyValueForDiff
		return {
			id: fullValue.id,
			name: fullValue.name,
			REVERT_VALUE_TO_PLAIN: true,
		}
	}
}


function valueObjectToString(v) {
	if (v.hasOwnProperty('id')) {
		return v.name || '[ID=' + v.id + ']';
	}
	else {
		console.log('Что-то не так', v)
		return v
	}
}

const publishTypeNames = {
	1: 'на внешнем',
	2: 'на внутреннем',
	3: 'везде', // почему-то не Везде (и вообще все значения в ловеркейс)
	4: 'не опубликован', // почему-то не "не опубликованО"
}

function acceptanceGetStorageValue(dr) {
	if (!dr) {
		return 'NO_DRAFT_PROVIDED--' + Math.floor(Math.random() * 1e7);
	}
	return [dr.siteId, dr.armId, dr.recordId].join();
}

function log() {
	if (window.localStorage.getItem('debug_drafts')) {
		console.log.apply(console, arguments);
	}
}
